"use strict";

define('rs/form/formobjects/factory',['rs/form/formobjects/base.formobject', 'rs/form/formobjects/group/group.formobject', 'rs/form/formobjects/radio/radio.formobject', 'rs/form/formobjects/label/label.formobject', 'rs/form/formobjects/textbox/textbox.formobject', 'rs/form/formobjects/check/check.formobject', 'rs/form/formobjects/attach/attach.formobject', 'rs/form/formobjects/textarea/textarea.formobject', 'rs/form/formobjects/person.finder/person.finder.formobject', 'rs/form/formobjects/sponsor.finder/sponsor.finder.formobject', 'rs/form/formobjects/datepicker/datepicker.formobject'], function (BaseFormObject, Group, Radio, Label, Textbox, Check, Attach, TextArea, PersonFinder, SponsorFinder, DatePicker) {
  var FormFactory = {
    FormObjects: {
      Base: BaseFormObject,
      question: Group,
      radio: Radio,
      label: Label,
      textbox: Textbox,
      checkbox: Check,
      attachment: Attach,
      textarea: TextArea,
      personfinder: PersonFinder,
      sponsorfinder: SponsorFinder,
      datepicker: DatePicker
    },
    getFormObjectByType: function getFormObjectByType(type) {
      type = type.toLowerCase();
      return FormFactory.FormObjects[type] || FormFactory.FormObjects.Base;
    },
    isCompoundType: function isCompoundType(type) {
      return type == "radio" || type == "checkbox";
    }
  };
  return FormFactory;
});

